module.exports = __webpack_public_path__ + "img/Feature.5af5c55b.png";